import { myralisTokens } from './tokens';

const styleId = 'myralis-techdocs-shadow-theme';
const scrollReadyAttribute = 'data-myralis-techdocs-scroll-ready';
const techDocsPathPattern = /\/catalog\/[^/]+\/[^/]+\/[^/]+\/docs(?:\/|$)/;

const shadowTheme = `
  :host {
    --md-primary-fg-color: ${myralisTokens.colors.primary};
    --md-primary-fg-color--dark: ${myralisTokens.colors.institutionalBlue};
    --md-accent-fg-color: ${myralisTokens.colors.coral};
    --md-default-bg-color: ${myralisTokens.colors.surface};
    --md-default-fg-color: ${myralisTokens.colors.text};
    --md-typeset-a-color: ${myralisTokens.colors.institutionalBlue};
    --md-code-bg-color: ${myralisTokens.colors.surfaceSoft};
    --md-code-fg-color: ${myralisTokens.colors.text};
    color: ${myralisTokens.colors.text};
    font-family: ${myralisTokens.typography.body};
  }

  html,
  body,
  .md-container,
  .md-main,
  .md-main__inner,
  .md-content,
  .md-sidebar,
  .md-nav,
  .md-typeset {
    background: ${myralisTokens.colors.surface} !important;
    color: ${myralisTokens.colors.text} !important;
    font-family: ${myralisTokens.typography.body} !important;
  }

  html,
  body {
    height: auto !important;
    min-height: 100% !important;
    overflow: visible !important;
  }

  .md-container,
  .md-main,
  .md-main__inner,
  .md-content,
  .md-content__inner {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .md-header,
  .md-tabs,
  .md-footer,
  .md-footer-meta {
    display: none !important;
  }

  .md-main__inner {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    max-width: none;
    margin: 0;
  }

  .md-content {
    flex: 1 1 auto;
    min-width: 0;
    margin-left: 0 !important;
  }

  .md-content__inner {
    margin: 0 !important;
    padding: 32px 38px 42px;
    background: ${myralisTokens.colors.surface} !important;
    border: 1px solid ${myralisTokens.colors.border};
    border-radius: ${myralisTokens.shape.radiusMedium};
    box-shadow: ${myralisTokens.shadow.subtle};
    width: 100%;
  }

  .md-content__inner::before {
    display: none;
  }

  .md-sidebar {
    position: static !important;
    top: auto !important;
    flex: 0 0 264px;
    align-self: flex-start;
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    padding-top: 8px;
    transform: none !important;
  }

  .md-sidebar__scrollwrap {
    position: static !important;
    height: auto !important;
    max-height: none !important;
    margin: 0 !important;
    overflow-y: visible !important;
    overflow-x: visible !important;
    background: ${myralisTokens.colors.surface};
    border: 1px solid ${myralisTokens.colors.border};
    border-radius: ${myralisTokens.shape.radiusMedium};
    box-shadow: ${myralisTokens.shadow.subtle};
    transform: none !important;
  }

  .md-sidebar--secondary {
    display: none !important;
  }

  .md-sidebar__inner,
  .md-nav {
    visibility: visible !important;
    opacity: 1 !important;
    transform: none !important;
  }

  .md-sidebar__inner > .md-nav > .md-nav__list {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  @media screen and (max-width: 76.1875em) {
    .md-main__inner {
      display: block;
    }

    .md-sidebar {
      position: static !important;
      width: auto;
      height: auto !important;
      max-height: none !important;
      transform: none !important;
    }

    .md-sidebar__scrollwrap {
      max-height: none !important;
      overflow: visible !important;
    }
  }

  .md-nav__title,
  .md-nav__link {
    color: ${myralisTokens.colors.institutionalBlue} !important;
    font-family: ${myralisTokens.typography.body} !important;
  }

  .md-sidebar .md-nav,
  .md-sidebar .md-nav__list {
    display: block !important;
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .md-nav__list {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .md-sidebar--primary .md-nav__item > .md-nav__list {
    height: auto !important;
    min-height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    overflow-x: visible !important;
    overflow-y: visible !important;
    flex: none !important;
  }

  .md-nav__title {
    margin: 0;
    padding: 14px 16px 8px;
    color: ${myralisTokens.colors.institutionalBlue} !important;
    font-family: ${myralisTokens.typography.heading} !important;
    font-size: 0.82rem;
    font-weight: 800 !important;
    line-height: 1.2;
  }

  .md-nav__list {
    padding: 0 10px 12px !important;
  }

  .md-nav__item {
    padding: 0 !important;
  }

  .md-nav__link {
    min-height: 34px;
    margin: 2px 0 !important;
    padding: 7px 10px !important;
    border-radius: ${myralisTokens.shape.radiusSmall};
    font-size: 0.74rem;
    line-height: 1.3;
    text-decoration: none !important;
    transition: background 120ms ease, color 120ms ease;
  }

  .md-nav__item .md-nav__list {
    margin-left: 8px !important;
    padding: 2px 0 6px 8px !important;
    border-left: 1px solid ${myralisTokens.colors.border};
  }

  .md-nav__link--active,
  .md-nav__link:is(:focus, :hover) {
    color: ${myralisTokens.colors.primary} !important;
    background: ${myralisTokens.colors.surfaceSoft} !important;
  }

  .md-nav__icon {
    color: ${myralisTokens.colors.institutionalBlue} !important;
  }

  .md-typeset h1,
  .md-typeset h2,
  .md-typeset h3,
  .md-typeset h4 {
    color: ${myralisTokens.colors.primary} !important;
    font-family: ${myralisTokens.typography.heading} !important;
    font-weight: 700 !important;
    letter-spacing: 0 !important;
  }

  .md-typeset h2 {
    padding-bottom: 0.45rem;
    border-bottom: 3px solid ${myralisTokens.colors.coral};
  }

  .md-typeset p,
  .md-typeset li {
    color: ${myralisTokens.colors.text} !important;
    font-size: 0.86rem;
    line-height: 1.65;
  }

  .md-typeset a {
    color: ${myralisTokens.colors.institutionalBlue} !important;
    font-weight: 700;
  }

  .md-typeset .headerlink {
    color: ${myralisTokens.colors.coral} !important;
  }

  .md-typeset table:not([class]) {
    border: 1px solid ${myralisTokens.colors.border};
    border-radius: ${myralisTokens.shape.radiusSmall};
    box-shadow: none;
  }

  .md-typeset table:not([class]) th {
    color: ${myralisTokens.colors.white} !important;
    background: ${myralisTokens.colors.primary} !important;
  }

  .md-typeset code,
  .md-typeset pre {
    color: ${myralisTokens.colors.text} !important;
    background: ${myralisTokens.colors.surfaceSoft} !important;
  }

  .md-typeset blockquote {
    color: ${myralisTokens.colors.institutionalBlue} !important;
    background: ${myralisTokens.colors.surfaceSoft} !important;
    border-left-color: ${myralisTokens.colors.coral} !important;
    border-radius: 0 ${myralisTokens.shape.radiusSmall} ${myralisTokens.shape.radiusSmall} 0;
  }
`;

const isTechDocsPath = () =>
  typeof window !== 'undefined' && techDocsPathPattern.test(window.location.pathname);

const scrollTechDocsToTop = () => {
  if (!isTechDocsPath()) {
    return;
  }

  const scrollOptions: ScrollToOptions = { top: 0, left: 0, behavior: 'auto' };

  window.scrollTo(scrollOptions);
  document.documentElement.scrollTo(scrollOptions);
  document.body.scrollTo(scrollOptions);

  const scrollableElements = Array.from(document.querySelectorAll<HTMLElement>('*')).filter(
    element =>
      element.scrollTop > 0 ||
      (element.scrollHeight > element.clientHeight &&
        ['auto', 'scroll'].includes(getComputedStyle(element).overflowY)),
  );

  for (const element of scrollableElements) {
    element.scrollTo(scrollOptions);
  }
};

const scheduleTechDocsTopReset = () => {
  for (const delay of [0, 50, 150, 350, 700, 1200, 2000, 3000]) {
    window.setTimeout(scrollTechDocsToTop, delay);
  }
};

const ensureTechDocsNavigationStartsAtTop = (shadowRoot: ShadowRoot) => {
  for (const link of Array.from(shadowRoot.querySelectorAll('.md-nav__link'))) {
    if (link.getAttribute('data-myralis-scroll-top') === 'true') {
      continue;
    }

    link.setAttribute('data-myralis-scroll-top', 'true');
    link.addEventListener('click', scheduleTechDocsTopReset);
  }
};

let routeScrollResetInstalled = false;

const installRouteScrollReset = () => {
  if (typeof window === 'undefined' || routeScrollResetInstalled) {
    return;
  }

  routeScrollResetInstalled = true;

  const historyWithReset = (method: 'pushState' | 'replaceState') => {
    const original = window.history[method];

    window.history[method] = function patchedHistoryMethod(...args) {
      const result = original.apply(this, args);
      scheduleTechDocsTopReset();
      return result;
    };
  };

  historyWithReset('pushState');
  historyWithReset('replaceState');
  window.addEventListener('popstate', scheduleTechDocsTopReset);
};

const applyTechDocsShadowTheme = () => {
  for (const element of Array.from(document.querySelectorAll('*'))) {
    const shadowRoot = element.shadowRoot;

    if (!shadowRoot || !shadowRoot.querySelector('.md-typeset')) {
      continue;
    }

    ensureTechDocsNavigationStartsAtTop(shadowRoot);

    if (element.getAttribute(scrollReadyAttribute) !== 'true') {
      element.setAttribute(scrollReadyAttribute, 'true');
      scheduleTechDocsTopReset();
    }

    const existingStyle = shadowRoot.getElementById(styleId);

    if (existingStyle) {
      if (existingStyle.textContent !== shadowTheme) {
        existingStyle.textContent = shadowTheme;
      }
      continue;
    }

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = shadowTheme;
    shadowRoot.appendChild(style);
  }
};

if (typeof document !== 'undefined') {
  const observer = new MutationObserver(applyTechDocsShadowTheme);

  const startObserver = () => {
    installRouteScrollReset();
    applyTechDocsShadowTheme();
    scheduleTechDocsTopReset();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
}
